
import { BaseApiClient } from "../baseApiClient";
import { 
  fetchBusinessById,
  fetchBusinessByOwnerId,
  updateBusiness,
  fetchSubscriptionDetails,
  updateOnboardingStatus
} from "./operations";
import { BusinessData, BusinessSubscriptionDetails, BUSINESS_INDUSTRIES, BusinessIndustry } from "./types";

/**
 * API client for business-related operations
 */
export const businessApiClient = {
  // Core operations
  fetchBusinessById,
  fetchBusinessByOwnerId,
  updateBusiness,
  fetchSubscriptionDetails,
  updateOnboardingStatus,
  
  // Constants
  BUSINESS_INDUSTRIES,
  
  // Cache management
  clearCache: () => {
    BaseApiClient.clearCache('business:');
  }
};

// Export types
export type { 
  BusinessData, 
  BusinessSubscriptionDetails,
  BusinessIndustry
};

// Export constants
export { BUSINESS_INDUSTRIES };
